import { FaUser } from "react-icons/fa"; 
//import { MdOutlinePets } from "react-icons/md"; 
import { IoLogoOctocat } from "react-icons/io"; 
import { FaPrescription } from "react-icons/fa"; 
import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import GxPrintLong from '../../gx/GxPrintLong';
import { useTranslation } from '../../hx/useTranslation';
//import { useNav } from '../../hx/useNav';
import CxButton from '../../cx/CxButton';
import CxInput from '../../cx/CxInput';
import CxHidden from '../../cx/CxHidden';
import CxDate from '../../cx/CxDate';
import CxTime from '../../cx/CxTime';
import CxChooser from '../../cx/CxChooser';
import CxSearcher from '../../cx/CxSearcher';
import CxButtonShowMore from '../../cx/CxButtonShowMore';
import CxNumber from '../../cx/CxNumber';
import CxState from '../../cx/CxState';
import CxIconButtonMenu from '../../cx/CxIconButtonMenu';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxAccordion from '../../cx/CxAccordion';
import CxTable from '../../cx/CxTable';
import CxSnackbar from '../../cx/CxSnackbar';
import CxDlgAlert from '../../cx/CxDlgAlert';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { clearStore, getStoreValue, getStoreValueBo, StoreClient, StoreCns, StoreRxAuto, StoreImage, StoreMultimedia, StoreAnimalWeight, isApp } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import { useAccess } from '../../hx/useAccess';
import { BiPrinter } from "react-icons/bi";
import GxSlsAuxTable from '../../gx/GxSlsAuxTable';
import CxStatic from '../../cx/CxStatic';
import { useNav } from '../../hx/useNav';
import * as FxTable from '../../fx/FxTable';
import * as FxEdition from '../../fx/FxEdition';
import * as FxStr from '../../fx/FxStr';
import * as FxFetch from '../../fx/FxFetch';
import { useWindowSize } from '../../hx/useWindowSize';
import CxIconVariant from '../../cx/CxIconVariant';

const MxAnimalCnsGrlForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.cnss'));
  const [{ navTo, navStack }] = useNav();
  const size = useWindowSize();

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);
  const [storeCns, setStoreCns] = useSessionStorage('StoreCns', StoreCns);
  const [storeRxAuto, setStoreRxAuto] = useSessionStorage('StoreRxAuto', StoreRxAuto);
  const [storeAnimalWeight, setStoreAnimalWeight] = useSessionStorage('StoreAnimalWeight', StoreAnimalWeight);
  const [storeImage, setStoreImage] = useSessionStorage('StoreImage', StoreImage);
  const [storeMultimedia, setStoreMultimedia] = useSessionStorage('StoreMultimedia', StoreMultimedia);

  const r_table_images = React.useRef(null);
  const r_table_multimedia = React.useRef(null);

  const r_table_weight = React.useRef(null);
  const r_accordion_weight = React.useRef(null);
  
  const r_snack_ask_save = React.useRef(null);
  const r_snack_error = React.useRef(null);

  const r_dlg_alert = React.useRef(null);
  
  let r_form = React.useRef(null);
  let r_sls_aux_table = React.useRef(null);
  let r_gx_print_long = React.useRef(null);

  let r_accordion_iinfo = React.useRef(null);

  let rf_soap_s = React.useRef(null);
  let rf_soap_o = React.useRef(null);
  let rf_soap_a = React.useRef(null);
  let rf_soap_p = React.useRef(null);
  
  let rf_remarks = React.useRef(null);
  let rf_date = React.useRef(null);
  let rf_time = React.useRef(null);
  let rf_txBranch = React.useRef(null);
  let rf_txEmployee = React.useRef(null);
  let rf_itStatusCns = React.useRef(null);
  let rf_txInternalInfo = React.useRef(null);

  const formLoad = async (data) => {
    if (data === null) { //nuevo registro
      rf_date.current.setValToday();
      rf_time.current.setValNow();
      rf_itStatusCns.current.setKeyAndVal("t_status_cns", "txTypeStatusCns", "itStatusCns", "000001.SRV");
      rf_txBranch.current.setKey(getStoreValue('StoreSession', 'inBranch'));
      rf_txBranch.current.setVal(getStoreValue('StoreSession', 'txBranch'));
      if (getStoreValueBo('StoreSession', 'boAutoSelEmployee')) {
        rf_txEmployee.current.setKey(getStoreValue('StoreSession', 'inEmployee'));
        rf_txEmployee.current.setVal(getStoreValue('StoreSession', 'txEmployee'));
      }
    } else {
      r_accordion_iinfo.current.setFontWeight(rf_txInternalInfo.current.isEmpty() ? 'normal' : 'bold');
    }
  }
  const formSave = async (lastSaveRv) => {
    storeCns.inCns = lastSaveRv.theValue;
    Promise.all([setStoreCns(storeCns)]).then((result) => {
      r_sls_aux_table.current.setTxLinkAuxId(storeCns.inCns);
      r_accordion_iinfo.current.setFontWeight(rf_txInternalInfo.current.isEmpty() ? 'normal' : 'bold');
      forceUIUpdate();
      //navBack(); // 2024-07-02 - daq: xq puede querer añadir ps.
    });
  }
  const formDelete = async (rv) => {
  }

  const doAI = () => {
    if (rf_soap_s.current.isEmpty()) {
      r_snack_error.current.setValAndOpen(trans('msg.missing_x', 'field.soap_part_s'));
      return;
    }
    if (rf_soap_o.current.isEmpty()) {
      r_snack_error.current.setValAndOpen(trans('msg.missing_x', 'field.soap_part_o'));
      return;
    }

    r_dlg_alert.current.clear();
    r_dlg_alert.current.setText(trans('msg.please_wait'));
    r_dlg_alert.current.setHasButtonClose(false);
    r_dlg_alert.current.setOpen(true);
    let record = {};
    record['inAnimal'] = storeClient.inAnimal;
    record['txSoapS'] = rf_soap_s.current.getVal();
    record['txSoapO'] = rf_soap_o.current.getVal();
    Promise.all([FxFetch.doJsonX('chat_gpt/cns', record)]).then((result) => {
      let rv = result[0].theValue;
      if (rv) {
        if (result[0].theStatus === 'error') {
          if (result[0].theValue === 'rv_chatgpt_usage_quota_has_been_exceeded') {
            r_snack_error.current.setValAndOpen(trans('msg.chatgpt_usage_quota_has_been_exceeded'));
          }
          if (result[0].theValue === 'rv_chatgpt_communication_error') {
            r_snack_error.current.setValAndOpen(trans('msg.chatgpt_communication_error'));
          }
          if (result[0].theValue === 'rv_chatgpt_error') {
            r_snack_error.current.setValAndOpen(trans('msg.chatgpt_error'));
          }
        } else {
          FxLog.infox('MxAnimalCnsGrlForm.doAI', '...rv:', rv);
          if (rf_remarks.current.isEmpty()) {
            rf_remarks.current.setVal('AI: ' + rv.split('|')[0]);
          }
          rf_soap_a.current.setVal('AI: ' + rv.split('|')[1]);
          rf_soap_p.current.setVal('AI: ' + rv.split('|')[2]);
        }
      }
      r_dlg_alert.current.setOpen(false);
    });
  }

  const doPrintX = async (option) => {
    let filter = {};
    filter['inCns'] = storeCns.inCns;
    let record = {};
    let inClient = storeClient.inClient;
    if (option === 'cns') {
      r_gx_print_long.current.setUrlBuild('cnss/report/grl_build');
      r_gx_print_long.current.setUrlGet('cnss/report/grl_get');
    };
    if (option === 'ins') {
      r_gx_print_long.current.setUrlBuild('cnss/report/instructions_build');
      r_gx_print_long.current.setUrlGet('cnss/report/instructions_get');
    };
    //----------------
    Promise.all([
      r_gx_print_long.current.setFilter(filter),
      r_gx_print_long.current.setRecord(record),
      r_gx_print_long.current.setInClient(inClient)
    ]).then((result) => {
      r_gx_print_long.current.doPrint();
    });
  }

  const openFormWeight = async (op, row) => {
    if (!storeCns.inCns) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      if (row === null) {
        storeAnimalWeight.inAnimalWeight = null;
      } else {
        storeAnimalWeight.inAnimalWeight = row.original.inAnimalWeight;
      }
      setStoreAnimalWeight(storeAnimalWeight);
      navTo("animal-weight-form");
    }
  }

  const openFormImage = async (op, row) => {
    if (!storeCns.inCns) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      storeImage.txLinkImageTable = 'n_cns';
      storeImage.txLinkImageId = storeCns.inCns;
      setStoreImage(storeImage);
      if (row === null) {
        storeClient.inImage = null;
      } else {
        storeClient.inImage = row.original.inImage;
      }
      setStoreClient(storeClient);
      navTo("client-image-form");
    }
  }

  const openFormMultimedia = async (op, row) => {
    if (!storeCns.inCns) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      storeMultimedia.txLinkMultimediaTable = 'n_cns';
      storeMultimedia.txLinkMultimediaId = storeCns.inCns;
      setStoreMultimedia(storeMultimedia);
      if (row === null) {
        storeClient.inMultimedia = null;
      } else {
        storeClient.inMultimedia = row.original.inMultimedia;
      }
      setStoreClient(storeClient);
      navTo("client-multimedia-form");
    }
  }

  const openFormRxsNewAuto = async () => {
    clearStore('StoreRxAuto', storeRxAuto);
    storeRxAuto.boFirstRender = true;
    storeRxAuto.boDataChanged = '0';
    storeRxAuto.inClient = storeClient.inClient;
    storeRxAuto.inAnimal = storeClient.inAnimal;
    storeRxAuto.txClient = storeClient.txClient;
    storeRxAuto.txAnimal = storeClient.txAnimal;

    storeRxAuto.boAuto = false;
    storeRxAuto.txRxAuto = null;
    storeRxAuto.itSeriesRx = null;
    storeRxAuto.inInvoice = null;
    Promise.all([setStoreRxAuto(storeRxAuto)]).then((result) => {
      navTo("animal-rx-auto-form");
    });
  }

  const openFormClient = () => {
    // Abrir en nueva pestaña si el sistema está disponible, o navegar
    // directamente como fallback (móvil / pestañas desactivadas).
    if (getStoreValueBo('StoreSession', 'boShowTabs')) {
      window.__mxMain_openTabWithNavigation('client-form', storeClient.txClient || trans('field.client'), false);
    } else {
      navTo('client-form');
    }
  };

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.patient')}: ${trans('field.cns')}-${trans('field.cns_grl')}`}
        xref={r_form}
        url="cnss"
        filterIdField='inCns'
        filterIdValue={storeCns.inCns}
        onFormLoad={formLoad}
        onFormSave={isFullAccess() && formSave}
        onFormDelete={isFullAccess() && formDelete}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonMenu onSelection={doPrintX} className="ibs_iconbutton_toolbar" icon={<BiPrinter />}
              options={[
                { id: 'cns', text: trans('field.print_x', 'field.cns'), },
                { id: 'ins', text: trans('field.print_x', 'field.instructions'), },
              ]}
            />

            {/* botón de receta */}
            {storeCns.inCns && <CxIconButtonNew icon={<FaPrescription fontSize="20px" style={{paddingTop:'2px'}} />} classType="ibs_iconbutton_toolbar" onClick={() => openFormRxsNewAuto()} tooltip={trans('field.new_0_x','field.rx')} />}

            {storeCns.inCns && navStack()[navStack().length-2]==='activity-vett-c-list' && <CxIconButtonNew 
              icon={getStoreValueBo('StoreSession', 'boShowTabs') ? (<CxIconVariant variant="client-go" />) : (<FaUser fontSize={19} style={{ margin: '2px 0 0 0px' }} />)} 
              classType="ibs_iconbutton_toolbar" onClick={openFormClient} tooltip={trans('field.open_x', 'field.client')} 
            />}
          </div>
        }
      >
        <CxHidden xref={useRef(null)} dbfield="n_cns.inClient" value={storeClient.inClient || ''} />
        <CxHidden xref={useRef(null)} dbfield="n_cns.inAnimal" value={storeClient.inAnimal || ''} />
        <CxHidden xref={useRef(null)} dbfield="n_cns.itStatusCns" value={'000001.SRV'} />
        <CxHidden xref={useRef(null)} dbfield="n_cns.txType" value={'G'} />

        <CxStatic label={`${FxStr.join(' / ', storeClient.txClient, storeClient.txAnimal)}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' />

        <CxDate xref={rf_date} label={trans('field.date')} dbfield={`n_cns.dtFrom`} required />
        <CxTime xref={rf_time} label={trans('field.time')} dbfield={`n_cns.dtFrom`} required />

        <CxChooser xref={rf_itStatusCns} label={trans('field.status')}
          dbfield="t_status_cns.txTypeStatusCns" dbfieldkey={`n_cns.itStatusCns`}
          table="t_status_cns"
          col_id="itStatusCns"
          col_tx="txTypeStatusCns"
          required
        />

        <CxChooser xref={rf_txBranch}
          label={trans('field.branch')}
          dbfield="n_branch.txBranch" dbfieldkey="n_cns.inBranch"
          id="n_branch"
          table="n_branch"
          col_id="inBranch"
          col_tx="txBranch"
          extra_filter_1={"boActive='1'"}
          required
        />

        <CxInput xref={rf_remarks} label={trans('field.remarks')} dbfield="n_cns.txRemarks" maxLength={255} />

        <CxSearcher xref={rf_txEmployee} label={trans('field.employee')}
          dbfield="n_employee.txEmployee" dbfieldkey="n_cns.inEmployee"
          url="employees" col_id="inEmployee" col_tx="txEmployee"
          tooltip={`${trans('field.employee')}`}
          columns={[
            { id: "0", Header: "ID", accessor: "inEmployee", show: false },
            { id: "1", Header: trans('field.employee'), accessor: row => rf_txEmployee.current.getTable().highlightText(row["txEmployee"]), width: '100%' },
          ]}
        />

        <CxInput xref={rf_soap_s} label={trans('field.soap_part_s')} dbfield="n_cns_grl.txSoapS" minRows={4} speech />
        <CxInput xref={rf_soap_o} label={trans('field.soap_part_o')} dbfield="n_cns_grl.txSoapO" minRows={4} speech />

        <CxButtonShowMore label={`[${trans('field.show_more').toUpperCase()}]`} style={{ margin: '4px 0 4px 0px' }} >

          <CxNumber xref={React.useRef(null)} label={trans('field.soap_gen_temperature')} dbfield="n_cns_grl.nuTemp" decimals={2} decimalsfixed="true" />
          <CxNumber xref={React.useRef(null)} label={trans('field.soap_gen_pulse_rate')} dbfield="n_cns_grl.nuPuls" decimals={0} />
          <CxNumber xref={React.useRef(null)} label={trans('field.soap_gen_respiratory_rate')} dbfield="n_cns_grl.nuResp" decimals={0} />

          <div style={{ display: 'flex', flexDirection: "row", flexWrap: "wrap", gap: '10px', width: "100%"  }} >
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_integument')} dbfield="n_cns_grl.nuIntegument" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_eyes')} dbfield="n_cns_grl.nuEyes" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_ears')} dbfield="n_cns_grl.nuEars" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_musculoskeletal')} dbfield="n_cns_grl.nuMusculoskeletal" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_cardiovascular')} dbfield="n_cns_grl.nuCardiovascular" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_respiratory')} dbfield="n_cns_grl.nuRespiratory" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_gastrointestinal')} dbfield="n_cns_grl.nuGastrointestinal" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_urinary')} dbfield="n_cns_grl.nuUrinary" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_reproductive')} dbfield="n_cns_grl.nuReproductive" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_endocrine')} dbfield="n_cns_grl.nuEndocrine" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_nervous')} dbfield="n_cns_grl.nuNervous" />
            <CxState mode='checkbox' xref={useRef(null)} label={trans('field.soap_gen_lymphatic')} dbfield="n_cns_grl.nuLymphatic" />
          </div>

        </CxButtonShowMore>

        <CxButton label={`${trans('field.iberix_suggest_you_x', `${trans('field.soap_part_a').split(' -')[0]} & ${trans('field.soap_part_p').split(' -')[0]}`)}`} 
          style={{ margin: '5px 0 0 0' }} 
          icon={<IoLogoOctocat fill='var(--ibs_color_white)' fontSize={15} />} 
          iconPosition="left"
          onClick={doAI} 
        />

        <CxInput xref={rf_soap_a} label={trans('field.soap_part_a')} dbfield="n_cns_grl.txSoapA" minRows={4} speech />
        <CxInput xref={rf_soap_p} label={trans('field.soap_part_p')} dbfield="n_cns_grl.txSoapP" minRows={4} speech />

        <CxInput xref={useRef(null)} label={trans('field.notes')} dbfield="n_cns.txNotes" minRows={4} />
        <CxInput xref={useRef(null)} label={trans('field.instructions')} dbfield="n_cns.txInstructions" minRows={4} />

        <CxAccordion xref={r_accordion_iinfo} title={trans('field.internal_information')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"}  >
          <CxStatic label={trans('msg.info_not_printed').toUpperCase()} border='none' fontcolor='var(--ibs_color_red)' fontsize='10px' />
          <CxInput xref={rf_txInternalInfo} dbfield="n_cns.txInternalInfo" minRows={4} />
        </CxAccordion>

        {isApp('vett') &&
          <CxAccordion xref={r_accordion_weight} title={trans('field.weight')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} defaultExpanded >
            <CxTable
              xref={r_table_weight}
              margin="-15px 0px 0px 0px"
              url="animals/weight"
              filter={`inAnimal='${storeClient.inAnimal}'`}
              onOpenForm={openFormWeight}
              hasButtonAdd={isFullAccess()}
              columns={[
                { id: "0", Header: "ID", accessor: "inAnimalWeight", show: false },
                { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtWeight"]), width: '15%' },
                { id: "2", Header: trans('field.weight'), accessor: row => FxTable.cellTo2r00(row["nuWeight"]), width: '15%' },
                { id: "3", Header: trans('field.remarks'), accessor: "txRemarks", width: '70%', show: size.isLarge },
              ]}
            />
          </CxAccordion>
        }

        <CxAccordion title={trans('field.images')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} defaultExpanded >
          <CxTable
            xref={r_table_images}
            margin="-15px 0px 0px 0px"
            url="images"
            filter={`n_image.txLinkImageTable='n_cns' and n_image.txLinkImageId='${storeCns.inCns}'`}
            onOpenForm={openFormImage}
            hasButtonAdd={isFullAccess()}
            disabledUntilUpgrade={!FxEdition.isInEdition('CLI_img')}
            columns={[
              { id: "0", Header: "ID", accessor: "inImage", show: false },
              { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtFrom"]), width: '15%' },
              { id: "2", Header: trans('field.type'), accessor: "txTypeImage", width: '15%' },
              { id: "3", Header: trans('field.remarks'), accessor: "txRemarks", width: '72%' /* 2% adicional para alineación */, show: size.isLarge },
            ]}
          />
        </CxAccordion>

        <CxAccordion title={trans('field.multimedia_files')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} defaultExpanded >
          <CxTable
            xref={r_table_multimedia}
            margin="-15px 0px 0px 0px"
            url="multimedia"
            filter={`n_multimedia.txLinkMultimediaTable='n_cns' and n_multimedia.txLinkMultimediaId='${storeCns.inCns}'`}
            onOpenForm={openFormMultimedia}
            hasButtonAdd={isFullAccess()}
            disabledUntilUpgrade={!FxEdition.isInEdition('CLI_mme')}
            columns={[
              { id: "0", Header: "ID", accessor: "inMultimedia", show: false },
              { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtMultimedia"]), width: '15%' },
              { id: "2", Header: trans('field.type'), accessor: "txTypeMultimedia", width: '15%' },
              { id: "3", Header: trans('field.issue'), accessor: "txIssue", width: '72%' /* 2% adicional para alineación */, show: size.isLarge },
            ]}
          />
        </CxAccordion>

      </GxForm>

      <GxSlsAuxTable xref={r_sls_aux_table} txLinkAuxTable={'n_cns'} txLinkAuxId={storeCns.inCns} rf_txEmployee={rf_txEmployee} />

      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />
      <CxSnackbar xref={r_snack_error} severity="error" />
      <GxPrintLong xref={r_gx_print_long} />
      <CxDlgAlert xref={r_dlg_alert} />

    </div>
  );

}

export default MxAnimalCnsGrlForm;
